<section class="sso-container">
  <mat-card class="mat-elevation-z6">
    <div class="content">
      <div class="img-container">
        <img
          src="https://lcptracker.com/wp-content/uploads/2024/03/LCPtracker-TM-Logo-Full-Color-cropped.png"
          width="175"
          alt="LCPtracker Logo"
        />
      </div>
      <div class="loading">
        <mat-progress-spinner
          class="example-margin"
          color="primary"
          mode="indeterminate"
          diameter="50"
        >
        </mat-progress-spinner>
      </div>
      <h4>Opening Wage Data Module</h4>
      <p>
        Checking your current session...
        <span class="font-medium">Just a moment.</span>
      </p>
    </div>
  </mat-card>
</section>
